const YOUTUBE_EMBED_BASE_URL = 'https://www.youtube.com/embed';

const getYouTubeEmbedURL = (youTubeVideoID: string): string => {
  return `${YOUTUBE_EMBED_BASE_URL}/${youTubeVideoID}`;
};

export default getYouTubeEmbedURL;
